export default "__VITE_ASSET__BBuMtSZk__"